import app, { Component } from 'apprun';
import { isValid, lookup_en } from '../utils';

export default class UserPropertyComponent extends Component {
    state = { }

    view = (state) => {
      if (!state.item) {return;}

      let network = '', url = '';
      if (state.item.value.indexOf(': ') > 0) {
        network = state.item.value.substr(0, state.item.value.indexOf(': '));
        url = state.item.value.replace(network + ': ', '');
      }
      return (
        <form id="SocialEditForm" class="form-horizontal" style={{ width: '450px' }}>
          <div class="row">
            <div class="col-sm-12">{state.item.dispName}</div>
            <div class="row">
              <span class="col-sm-3">Network</span>
              <span class="col-sm-9">URL</span>
            </div>
            <div class="row">
              <span class="col-sm-3">
                <select id="selectedNetwork" name="SocialNetworking" oninput={e => network = (e.target.options[e.target.selectedIndex].text)} data-validate>
                  <option value=' '>[Select]</option>
                  {lookup_en.SocialNetworking.map(r => <option value={r.id} selected={r.value === network ? 'selected' : null}>{r.value}</option>)}
                </select>
              </span>
              <input id="inpUrl" class="col-sm-8" size="400" value={url || ''}  oninput={(e) => {url = e.target.value;}} data-validate/>
            </div>
            <div class="row">
              <div id="selectedNetworkErrMsg" class="text-danger col-sm-3"></div>
              <div id="inpUrlErrMsg" class="text-danger col-sm-9"></div>
            </div>
          </div>
          <div class="edit-buttons">
            <a
              type="button"
              class="btn btn-primary btn-xs"
              style={(state.item.required || (state.item.value===''))?{ display:'none' }:{ display:'inline-block' }}
              onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
            </a>
            <a
              type="button"
              class="btn btn-primary btn-xs"
              onclick={e => this.run('save', e, network, url)}>
            save
            </a>
            <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('cancel')}>
            cancel
            </a>
          </div>
        </form>
      );
    };

  update = {

    save: (state, e, network, url) => {
      state.newVal = network + ': ' + url;
      if(!isValid('SocialEditForm')) { e.preventDefault(); return;}
      state.caller.run(state.save, state.item, state.panelId, state.newVal);
    },

    cancel: (state) => {
      state.caller.run(state.cancel, state.panelId);
    },
  }

  mounted = ({ state }) => state;
}
